<template>
  <div class="myRegistration">
        <h3 class="containner-title">{{$t("message.recent_registration_information")}}</h3>
        <div class="card-body border" style="background-color: #f1f1f1;">
            <form class="form" v-on:submit.prevent>
              <div class="row mb-2">
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.last_name")}}</label>
                  <input type="text" 
                    v-model="search.lastname"
                    class="form-control" 
                    :placeholder='$t("message.last_name")'
                    aria-label="Last name">
                </div>
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.first_name")}}</label>
                  <input type="text" 
                    v-model="search.firstname"
                    class="form-control" 
                    :placeholder='$t("message.first_name")'
                    aria-label="First name">
                </div>
                
                 <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.phone")}}</label>
                  <input type="text" 
                    v-model="search.phone"
                    class="form-control" 
                    :placeholder='$t("message.phone")'>
                </div>
                
              </div>
              <div class="row mb-2">
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.register_type")}}</label>
                  <select
                    class="form-select"
                    :placeholder='$t("message.register_type")'
                    v-model="search.type"
                  >
                    <option value="" selected>Choose...</option>
                    <option value="1">New</option>
                    <option value="2">CPE</option>
                  </select>
                </div>
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.business_type")}}</label>
                  <select
                    class="form-select"
                    v-model="search.type_business"
                  >
                    <option value="" selected>Choose...</option>
                    <option value="1">{{$t("message.stock_business")}}</option>
                    <option value="4">{{$t("message.found")}}</option>
                    <option value="2">{{$t("message.derivative_business")}}</option>
                    <option value="3">{{$t("message.public")}}</option>
                  </select>
                </div>
                 <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.nationality")}}</label>
                  <select
                    v-model="search.is_foreigner"
                    class="form-select"
                  >
                    <option value="" selected>Choose...</option>
                    <option value="0">Local</option>
                    <option value="1">Foreigner</option>
                  </select>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-12" style="text-align: right;margin-top: 5px;">
                  <button class="btn btn-dark m-1"><i class="fas fa-print"></i></button>
                  <button class="btn btn-success" @click="exportExcel"><i class="fas fa-file-excel"></i> {{$t("message.export")}}</button>
                  <button class="btn btn-primary m-1" @click="loadData"><i class="fas fa-search"></i> {{$t("message.search")}}</button>
                </div>
              </div>
            </form>
        </div>
        <div class="row">
          
            <label class="text-end fs-5 fw-bold p-2">{{$t("message.total")}}:
              <span class="text-primary">{{listRegister.length}} {{$t("message.neak")}}</span>
            </label> 
          
        </div>
        <table class="table table-bordered">
          <thead class="table-dark">
            <tr>
              <th class="align-middle">#</th>
              <th class="align-middle" style="width: 300px;">{{$t("message.name")}}</th>
              <th class="text-center align-middle" style="width: 150px;">{{$t("message.company")}}</th>
              <th class="text-center align-middle">{{$t("message.register_type")}}</th>
              <th class="text-center align-middle">{{$t("message.business_type")}}</th> 
              <th class="text-center align-middle">{{$t("message.register_date")}}</th>
              <th class="text-center align-middle">{{$t("message.action")}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in listRegister" :key="index">
              <td style="vertical-align: middle;width: 30px;">{{index+1}}</td>
            
              <td style="vertical-align: middle;">
                <div class="d-flex align-items-center">
                  <img :src="item.participant.avatar" class="avatar" alt="...">
                  <span class="ms-2">
                    {{$t("message.name")}}: <b>{{item.participant.lastname}} {{item.participant.firstname}}</b><br>
                    {{$t("message.gender")}}: <b>{{item.participant.gender==1? 'M' : 'F'}}</b><br>
                    {{$t("message.dob")}}: <b>{{item.participant.dob}} </b><br>

                    {{$t("message.marital_status")}}: <b>{{item.participant.marital_status == 1 ? 'នៅលីវ' : item.participant.marital_status == 2 ? 'បានរៀបការ' :''}}</b><br>

                    {{$t("message.phone")}}: <b>{{item.participant.phone}} </b><br>
                    {{$t("message.email")}}: <b>{{item.participant.email}}</b><br>
                    {{$t("message.nationality")}}: <b>{{item.participant.nationality_name}}</b><br>
                  </span>
                </div>
              </td>
              <th class="text-center" style="vertical-align: middle;">{{item.participant.occupations.company}}</th>
              <td class="text-center" style="vertical-align: middle;">{{item.apply_for == 1 ? 'NEW' : 'CPE'}}</td>
              <td class="text-center" style="vertical-align: middle;">{{item.type_business_name}}</td>
              <td class="text-center" style="vertical-align: middle;">{{item.updated_at}}</td>
              <td class="text-center" style="vertical-align: middle;" >
                <router-link class="btn btn-primary" :to="{ name: 'showParticipant' , params:{id:item.id}}"><i class="far fa-edit"></i></router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
</template>
<script>
import axios from "@/axios";
export default {
  data() {
    return {
      search:{firstname:'',lastname:'',gender:'',phone:'',type_business: '', is_foreigner: ''},
      listRegister: []
    };
  },
  computed: { 
    getBusinessTypeTest() {
      return this.$t("message.no");
    },
    getBusinessType(){
      return (t) =>{
        switch (t){
            case '1':
            case 1:
              return this.$t("message.stock_business");
            case '2':
            case 2:
              return this.$t("message.derivative_business");
            case 4:
              return this.$t("message.found");
            case '19':
            case 19:
                return this.$t("message.public") + ' - ' + this.$t("message.stock_business");
            case 20:
            case '20':
                return this.$t("message.public") + ' - ' + this.$t("message.derivative_business");
            default:
                return t;
        }
      }
    }
  },
  methods: {
    showLoader() {
      return this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: false,
      });
    },
    async loadData(){
      let loader = this.showLoader();
      const respone = await axios.get("get-new-register", {
        params: this.search,
        headers: {
          Authorization: "Bearer " + this.$store.getters.getAuthToken
        }
      });
      if (respone.status == 200) {
        this.listRegister = respone.data.data;
      }
      loader.hide();
    },
    async exportExcel(){
      this.$swal
        .fire({
          title: "តើអ្នកចង់ export excel មែនទេ?",
          showCancelButton: true,
          confirmButtonText: `យល់ព្រម`,
          cancelButtonText: `បោះបង់`
        })
        .then(async (result) => {
          if (result.isConfirmed) {
              let loader = this.showLoader();
              const response = await axios.post("export-new-registration",this.search ,{
                headers: {
                  Authorization: "Bearer " + this.$store.getters.getAuthToken
                },
                responseType: "blob"
              });
              const type = response.headers["content-type"];
              const blob = new Blob([response.data], {
                type: type,
                encoding: "UTF-8"
              });
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "new-registration.xlsx";
              link.click();
              loader.hide();
          }
        });
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
   
  }, components: {
   
  }
};
</script>
<style scoped>

div.content {
  margin-left: 200px;
  padding: 25px;
  height: auto;
  margin-top: 0;
}

@media screen and (max-width: 700px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  .sidebar a {
    float: left;
  }
  div.content {
    margin-left: 0;
  }
}

.footer {
  margin-left: 200px;
}
</style>
